module.exports = __webpack_public_path__ + "assets/img/pages/delivery/pickup.jpg?4048";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pages/delivery/pickup.jpg
// module id = 16
// module chunks = 0